export default __webpack_public_path__ + "static/media/7.31bb0967.webp";